var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLoginPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_login_password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C9.86693464,0 11.7857143,1.79182182 11.7857143,4.00236948 L11.785,6 L13.0081158,6 C14.1082031,6 15,6.90195036 15,8.0085302 L15,15.9914698 C15,17.1007504 14.1066027,18 13.0081158,18 L1.99188419,18 C0.891796927,18 0,17.0980496 0,15.9914698 L0,8.0085302 C0,6.8992496 0.893397331,6 1.99188419,6 L3.214,6 L3.21428571,4.00236948 C3.21428571,1.79192185 5.13788159,0 7.5,0 Z M7.5,10 C6.31653268,10 5.35714286,10.8954305 5.35714286,12 C5.35714286,13.1045695 6.31653268,14 7.5,14 C8.68346732,14 9.64285714,13.1045695 9.64285714,12 C9.64285714,10.8954305 8.68346732,10 7.5,10 Z M7.5,2 C6.31959739,2 5.35714286,2.89812584 5.35714286,4.00236948 L5.357,6 L9.642,6 L9.64285714,4.00236948 C9.64285714,2.89616855 8.68322844,2 7.5,2 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-1",
    transform: "translate(-849.000000, -1039.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_login_password",
    transform: "translate(844.000000, 1036.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Depth",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#42526E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color",
    mask: "url(#mask-2)",
    fill: "#A3AFB7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.000000, -3.000000)",
    id: "N500"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 24 26 24 26 0 0 0"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginPassword);
export default __webpack_public_path__ + "static/media/icon_login_password.9e97fd22a6ffc0e38f118e72a694203f.svg";
export { ForwardRef as ReactComponent };